"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdateDoiSettingsRequestStatus = exports.getFetchDoiSettingsRequestStatus = exports.getDoiSettings = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getDoiSettings = function getDoiSettings(state) {
  return state.modules.marketing.email.entities.doiSettings;
};

exports.getDoiSettings = getDoiSettings;
var getFetchDoiSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.DoiSettingsActionTypes.FETCH_DOI_SETTINGS);
exports.getFetchDoiSettingsRequestStatus = getFetchDoiSettingsRequestStatus;
var getUpdateDoiSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.DoiSettingsActionTypes.UPDATE_DOI_SETTINGS);
exports.getUpdateDoiSettingsRequestStatus = getUpdateDoiSettingsRequestStatus;